//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
let d=[[[1,"EndOffset",0,"Expression",0],[0,"Option",1,0],[1,"StartOffset",0,"Expression",0]],[[["value_expression"],"SetStartOffset",{},1,1],[["value_expression"],"SetEndOffset",{},1,1],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.FeatureOffset = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.FeatureOffset";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.Type = Object.freeze({
    "NoOffset" : "NoOffset", "NonsymmetricOffset" : "NonsymmetricOffset", "SymmetricOffset" : "SymmetricOffset", "SingleOffset" : "SingleOffset"});

export default SPLM;